export default {
  built_before_date: 'Built before 9/29/25',
  built_after_date: 'Built 9/29/25 or later',
  all_switches: 'All Switches',
  all_solenoids: 'All Solenoids',
  current_options: ['2A', '5A', '20A'],
  search_results: 'Search Results',
  recently_viewed: 'Recently viewed',
  vehicle_search_explainer:
    'Enter one or more serial numbers to look up vehicles.',
  only_show_compatible_features: 'Only Show Compatible Features',
  school_bus_filter: 'Limit Search to School Bus Features',
  switch_number: 'Switch Number',
  select_criteria: 'Select criteria',
  current_a: 'Current (A)',
  create_feature: 'Create Feature',
  results_with_search_string: (searchString = '') =>
    `Search Results${searchString ? ` “${searchString}”` : ''}`,
  header_text: 'header',
  amps_a: 'A',
  amps: 'A',
  ff_view_fast_features: 'View Fast Features',
  copy: 'Copy',
  ff_copy_tooltip: 'Copy the Feature number',
  ff_copied_tooltip: 'Feature number copied',
  ff_column_description: 'Description',
  ff_column_ecu: 'ECU',
  ff_column_feature_no: 'Feature No.',
  ff_column_feature_current: 'Output Type',
  ff_column_switch_name: 'Switch Input Name',
  ff_column_switch_part_no: 'Switch P/N',
  ff_column_solenoid: 'Solenoid',
  ff_no_results_warning:
    'Your search returned no results. Please try different filter options to view available Features.',
  ff_filter_by_output_type: 'Filter by Output Type:',
  ff_filter_by_switch_no: 'Filter by Switch No.',
  ff_filter_by_solenoid: 'Filter by Solenoid',
  ff_filter_by_ecu: 'Filter by ECU:',
  ff_fast_features_description:
    'These Features can be used to rapidly upfit your Plus Series and X-Series vehicles.',
  select_signal: 'Select the signal type you want to use for this input:',
  signal_type_input: {
    value: 'Value: You can enter a number within the specified value range.',
    error:
      "Error: This will program the value for the signal if it's in error.",
    sna: "SNA: This will program the value for the signal if it's not available.",
  },
  // PBI 481284 – Fast Feature Management
  fast_feature_control: 'Fast Feature Control',
  fast_feature_status_label: 'Fast Feature',
  edit_fast_feature_details: 'Edit Fast Feature Details',
  assign_fast_feature_details: (featureNumber, revision) =>
    `Assign Fast Feature Details: ${featureNumber} Rev. ${revision}`,
  fast_feature_added: 'Fast Features status updated.',
  fast_feature_removed: 'Fast Features status updated.',
  fast_feature_details_updated: 'Fast Feature Details Updated',
  fast_feature_status_error: 'The status of this Fast Feature was not updated.',
  fast_feature_save_error: 'Fast Feature Status Update Error',
  ff_output_type: 'Output Type',
  ff_output_details: 'Output Details',
  ff_input_type: 'Input Type',
  ff_input_details: 'Input Details',
  ff_code_35m: '35M Code',
  ff_output_label: (n) => `Output ${n} Details`,
  ff_select_output_type_first: 'Select an Output Type first',
  ff_select_input_type_first: 'Select a Switch input type first',
  ff_fast_feature_filter: 'Fast Feature Filter',
  ff_feature_description_label: 'Feature Description',
  ff_min_diag_variant_label: 'Minimum Diagnostic Variant',
  ff_ecu_label: 'ECU',
  ff_not_configured: 'Not configured',
  ff_not_selected: 'Not Selected',
  ff_selected: 'Selected',
  ff_filters: 'Filters',
  ff_output_filter_label: 'Output',
  ff_configured: 'Configured',
  ff_output_tile_label: (n) => `Output ${n}`,
  ff_confirm: 'Confirm',
  ff_loading_details: 'Loading details...',
  ff_load_error: 'Could not load fast feature details.',
  ff_retry: 'Retry',
}
